import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import camelcaseKeys from "camelcase-keys";
import {
  onAddCustomerNotInBroadcastList,
  onCreateBroadcastList,
  onDeleteBroadcastList,
  onGetAllBroadcastList,
  onGetBroadcastListCustomerPage,
  onGetBroadcastListDetail,
  onGetBroadcastListNotIn,
  onGetBroadcastListPage,
  onUpdateBroadcastList,
} from "services/apis/broadcastList";
import snakecaseKeys from "snakecase-keys";

export const doCreateBroadcastList = createAsyncThunk(
  "broadcastList/doCreateBroadcastList",
  async params => {
    const result = await onCreateBroadcastList(params.data);
    if (!result) {
      return;
    }
    // dispatch(doGetBroadcastListPage(params.queries));
    return camelcaseKeys(result.data);
  }
);

export const doGetBroadcastListPage = createAsyncThunk(
  "broadcastList/doGetBroadcastListPage",
  async params => {
    const result = await onGetBroadcastListPage(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doGetBroadcastListCustomerPage = createAsyncThunk(
  "broadcastList/doGetBroadcastListCustomerPage",
  async params => {
    const result = await onGetBroadcastListCustomerPage(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doGetBroadcastListDetail = createAsyncThunk(
  "broadcastList/doGetBroadcastListDetail",
  async params => {
    const result = await onGetBroadcastListDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result.data);
  }
);

export const doUpdateBroadcastList = createAsyncThunk(
  "broadcastList/doGetBroadcastListDetail",
  async (params, { dispatch }) => {
    const result = await onUpdateBroadcastList(params);
    if (!result) {
      return;
    }
    dispatch(doGetBroadcastListDetail(params.id));
    return result;
  }
);

export const doDeleteBroadcastList = createAsyncThunk(
  "broadcastList/doDeleteBroadcastList",
  async params => {
    const result = await onDeleteBroadcastList(params.id);
    if (!result) {
      return;
    }
    return result;
    // dispatch(doGetBroadcastListPage(params.queries));
  }
);

export const doGetAllBroadcastList = createAsyncThunk(
  "broadcastList/doGetAllBroadcastList",
  async () => {
    const result = await onGetAllBroadcastList();
    if (!result) {
      return;
    }
    return result;
  }
);

export const doGetBroadcastListNotIn = createAsyncThunk(
  "broadcastLis/doGetBroadcastListNotIn",
  async params => {
    const result = await onGetBroadcastListNotIn(snakecaseKeys(params));
    if (!result) {
      return;
    }
    return result.data;
  }
);

export const doAddCustomerNotInBroadcastList = createAsyncThunk(
  "broadcastList/doAddCustomerNotInBroadcastList",
  async params => {
    const result = await onAddCustomerNotInBroadcastList(snakecaseKeys(params));
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  broadcastListPage: [],
  broadcastListDetail: {},
  pagination: {
    page: 1,
    size: 10,
  },
  isLoading: false,
  list: [],
  uploadList: [],
  count: 0,
  totalCount: 0,
  broadcastListId: null,
  broadcastListUpload: [],
};

const slice = createSlice({
  name: "broadcastList",
  initialState: initialState,
  reducers: {
    doGetListUpload: (state, action) => {
      const { payload } = action;
      state.uploadList = payload.data;
      state.count = payload.count;
      state.broadcastListId = payload.broadcastListId;
      if (payload.totalCount) {
        state.totalCount = payload.totalCount;
      }
      if (payload.broadcastListUpload) {
        state.broadcastListUpload = payload.broadcastListUpload;
      } else {
        state.broadcastListUpload.push({
          list: payload.data,
          count: payload.count,
          totalCount: payload.totalCount,
          broadcastListId: payload.broadcastListId,
          workspaceId: payload.workspaceId,
        });
      }
    },
  },
  extraReducers: {
    [doCreateBroadcastList.pending]: state => {
      state.isLoading = true;
    },
    [doCreateBroadcastList.rejected]: state => {
      state.isLoading = false;
    },
    [doCreateBroadcastList.fulfilled]: state => {
      state.isLoading = true;
    },
    [doUpdateBroadcastList.pending]: state => {
      state.isLoading = true;
    },
    [doUpdateBroadcastList.rejected]: state => {
      state.isLoading = false;
    },
    [doUpdateBroadcastList.fulfilled]: state => {
      state.isLoading = true;
    },
    [doGetBroadcastListDetail.pending]: state => {
      state.isLoading = true;
      state.broadcastListDetail = {};
    },
    [doGetBroadcastListDetail.rejected]: state => {
      state.isLoading = false;
      state.broadcastListDetail = {};
    },
    [doGetBroadcastListDetail.fulfilled]: (state, action) => {
      state.isLoading = false;
      const { payload } = action;
      state.broadcastListDetail = { ...payload };
    },
    [doGetBroadcastListPage.pending]: state => {
      state.isLoading = true;
      state.broadcastListPage = [];
    },
    [doGetBroadcastListPage.rejected]: state => {
      state.isLoading = false;
      state.broadcastListPage = [];
    },
    [doGetBroadcastListPage.fulfilled]: (state, action) => {
      const { payload } = action;
      state.isLoading = false;
      if (typeof payload === "object") {
        state.broadcastListPage = [...payload.content];
        state.pagination.pageNumber = payload.pageNumber;
        state.pagination.pageSize = payload.pageSize;
        state.pagination.totalElements = payload.totalElements;
        state.pagination.totalPages = payload.totalPages;
        state.pagination.numberOfElements = payload.numberOfElements;
      }
    },
    [doGetAllBroadcastList.fulfilled]: (state, action) => {
      const { payload } = action;
      if (payload) {
        state.list = payload;
      }
    },
  },
});

const { reducer, actions } = slice;
export const { doGetListUpload } = actions;
export default reducer;

export const getIsLoading = createSelector(
  state => state.broadcastList.isLoading,
  isLoading => isLoading
);

export const getBroadcastListDetail = createSelector(
  state => state.broadcastList.broadcastListDetail,
  broadcastListDetail => broadcastListDetail
);

export const getBroadcastListPage = createSelector(
  state => state.broadcastList.broadcastListPage,
  broadcastListPage => broadcastListPage
);

// export const getAllBroadcastList = createSelector(
//   state => state.broadcastList.list,
//   list => list
// );

export const getPaginationBroadcastList = createSelector(
  state => state.broadcastList.pagination,
  pagination => pagination
);
